const { encode } = require('csv-line')

module.exports = (input, { firstLineIsHeader = true } = {}) => {
	let csv = ''

	if (input && Array.isArray(input) && input.length > 0 && typeof input[0] === 'object') {
		csv = firstLineIsHeader ? [ encode(Object.keys(input[0])) ] : []
		csv = [ ...csv, ...input.map(item => encode(Object.values(item))) ]

		return csv.join('\n')
	}

	return csv
}
